import React from 'react';
import Avatar from '../../components/Avatar';
import type { DocumentType } from '../../graphql/generated/gql';
import { gql } from '../../graphql/generated/gql';
import SettingsImageEditor from '../../settings/SettingsImageEditor';
import useUpdateUserProfile from './useUpdateUserProfile';

const USER_FRAGMENT = gql(`
  fragment UserProfileAvatarEditor_user on User {
    id
    ...Avatar_user
  }
`);

interface UserProfileAvatarEditorProps {
  onUpload?: () => void;
  user: DocumentType<typeof USER_FRAGMENT>;
  size?: React.ComponentProps<typeof Avatar>['size'];
}

const UserProfileAvatarEditor = ({
  onUpload,
  user,
  size = 'large',
}: UserProfileAvatarEditorProps) => {
  const updateUserProfile = useUpdateUserProfile({
    user,
  });

  const handleUpload = (avatar: File) =>
    updateUserProfile({ avatar }).then(onUpload);

  return (
    <SettingsImageEditor onUpload={handleUpload}>
      <Avatar size={size} user={user} />
    </SettingsImageEditor>
  );
};

export default UserProfileAvatarEditor;
